export const COUNTRIES = ['India', 'United Arab Emirates', 'United States', 'United Kingdom', 'Singapore', 'Other'];

export const STATES = [
  'Andhra Pradesh', 'Assam', 'Bihar', 'Chhattisgarh', 'Delhi', 'Goa', 'Gujarat', 'Haryana',
  'Himachal Pradesh', 'Jharkhand', 'Karnataka', 'Kerala', 'Madhya Pradesh', 'Maharashtra',
  'Odisha', 'Punjab', 'Rajasthan', 'Tamil Nadu', 'Telangana', 'Uttar Pradesh', 'Uttarakhand',
  'West Bengal',
];

export const CITIES_BY_STATE = {
  Karnataka: ['Bengaluru', 'Mysuru', 'Hubli', 'Mangaluru', 'Belagavi'],
  Maharashtra: ['Mumbai', 'Pune', 'Nagpur', 'Nashik', 'Thane'],
  Delhi: ['New Delhi', 'Dwarka', 'Rohini'],
  Gujarat: ['Ahmedabad', 'Surat', 'Vadodara', 'Rajkot'],
  'Tamil Nadu': ['Chennai', 'Coimbatore', 'Madurai', 'Salem'],
  Telangana: ['Hyderabad', 'Warangal', 'Karimnagar'],
  'Uttar Pradesh': ['Lucknow', 'Kanpur', 'Varanasi', 'Agra'],
  Rajasthan: ['Jaipur', 'Jodhpur', 'Udaipur'],
  'West Bengal': ['Kolkata', 'Howrah', 'Siliguri'],
  Kerala: ['Kochi', 'Thiruvananthapuram', 'Kozhikode'],
  Punjab: ['Ludhiana', 'Amritsar', 'Chandigarh'],
  'Madhya Pradesh': ['Indore', 'Bhopal', 'Gwalior'],
  Bihar: ['Patna', 'Gaya'],
  Haryana: ['Gurugram', 'Faridabad'],
};

export const STATES_DEFAULT = STATES;